import React, { Fragment, useState } from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Packages from '../../components/Packages/packages';
import animation_video from "../../images/video-animation/animation-video.mp4";
import AnimationImg1 from "../../images/video-animation/image-1.jpg";
import AnimationImg2 from "../../images/video-animation/image-2.jpg";
import AnimationImg3 from "../../images/video-animation/image-3.jpg";
import AnimationImg4 from "../../images/video-animation/image-4.jpg";
import AnimationImg5 from "../../images/video-animation/image-5.jpg";
import AnimationImg6 from "../../images/video-animation/image-6.jpg";
import AnimationImg7 from "../../images/video-animation/image-7.jpg";
import AnimationImg8 from "../../images/video-animation/image-8.jpg";
import AnimationImg9 from "../../images/video-animation/image-9.jpg";
import VideoAnimationService1 from "../../images/video-animation/videoanimationservices1.mp4";
import VideoAnimationService2 from "../../images/video-animation/videoanimationservices2.mp4";
import AnimationAndIllustrationTestimonial from '../../components/Testimonials/AnimationAndIllustrationTestimonial';
import { Link } from 'react-router-dom'
import Bg from '../../images/shapes/memecoin_bg_shape_1.svg'
import Bg2 from '../../images/shapes/btn_mask_bg.png'
import shape3 from '../../images/shapes/shape_chain_1.svg'
import shape4 from '../../images/shapes/shape_chain_2.svg'
import Modal from '../../components/Modal/Modal';

const AnimationAndIllustration = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    return (
        <Fragment>
            <div className='index_memecoin page_wrapper'>
                <Header />
                <main className="page_content">

                    {/* Hero */}

                    <section className="memecoin_hero_section section_decoration text-center" style={{ backgroundImage: `url(${Bg})` }}>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-12">
                                    <h1 style={{ fontSize: '4rem' }} className="hero_title text-uppercase" data-aos="fade-up" data-aos-duration="800">
                                        TURNING CONCEPTS INTO POWERFUL ANIMATED VIDEOS
                                    </h1>
                                    <p className="hero_description" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                        GetLogoAndDesign offer video animation and illustration services to provide you the opportunity to give your ideas a life! Our focus is to showcase our skilled animation craftsmanship through our services.
                                    </p>
                                    <ul className="btns_group unordered_list justify-content-center p-0" data-aos="fade-up" data-aos-duration="800" data-aos-delay="200">
                                        <li>
                                            <button className="memecoin_btn bg-light" onClick={openModal}>
                                                <span className="btn_label">Get a Free Quote</span>
                                                <span className="btn_bg" style={{ maskImage: `url(${Bg2})` }}></span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="decoration_item shape_chain_1">
                            <img src={shape3} alt="Shape Chain" />
                        </div>
                        <div className="decoration_item shape_chain_2">
                            <img src={shape4} alt="Shape Chain" />
                        </div>
                    </section>


                    <section id="id_token_offer" className="memecoin_countdown_section section_decoration mt-5 pt-5">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-lg-6">
                                    <video muted autoPlay loop preload="none" style={{ borderRadius: "30px" }}>
                                        <source src={animation_video} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                                <div className="col-lg-6">
                                    <div className="memecoin_heading_block" data-aos="fade-up" data-aos-duration="800">
                                        <h2 className="heading_text text-uppercase pt-4">
                                            WHY 2D AND 3D ANIMATION SHOULD BE YOUR NEXT GO-TO FOR ENGAGEMENT
                                        </h2>
                                        <p className="heading_description pe-lg-5 mt-3">
                                            2D Animation: Tell Your Story with Simplicity
                                        </p>
                                        <p className="heading_description mb-0 pe-lg-5 mt-3">
                                            2D animation is a fantastic and simple way to communicate your ideas. Its smooth movement and flat designs draw attention to it right away. All kinds of content, such as explainer videos, social media posts, and short ads, benefit greatly from 2D animation. It is affordable, easy to update, and perfect for businesses that want to use creative and clear images to engage their clients. At GetLogoAndWebsite, we help you turn your ideas into captivating animated stories.
                                        </p>
                                        <p className="heading_description mb-0 pe-lg-5 mt-3">
                                            3D Animation: Bring Your Ideas to Life in 3D
                                        </p>
                                        <p className="heading_description mb-0 pe-lg-5 mt-3">
                                            With the help of 3D animation, your audience can see your concept or product from every angle. It looks striking, real, and modern. Because 3D animation can show fine details that static images cannot, it is perfect for walkthroughs, brand videos, and product demos. It creates a strong impression and distinguishes your brand. At GetLogoAndWebsite, our 3D animations not only look amazing but also successfully communicate your message.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>


                    <section
                        id="id_memecoin_service_section"
                        className={`memecoin_service_section z-2 position-relative`}
                        style={{ padding: "90px 0" }}
                    >
                        <div className="container">
                            <div className="memecoin_heading_block text-center">
                                <h2 className="heading_text text-uppercase mb-0">
                                    OUR ANIMATION AND ILLUSTRATION PORTFOLIO
                                </h2>
                                <p className='mt-4'>
                                    Check out our animation portfolio, a diverse collection showcasing the skills of our creative video animators. From captivating character animations to explainer videos, our portfolio showcases our dedication to excellence and originality in every project.
                                </p>
                            </div>

                            <div className="row">
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={AnimationImg1} alt="website design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={AnimationImg2} alt="website design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={AnimationImg3} alt="website design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={AnimationImg4} alt="website design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={AnimationImg5} alt="website design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={AnimationImg6} alt="website design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={AnimationImg7} alt="website design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={AnimationImg8} alt="website design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={AnimationImg9} alt="website design" />
                                </div>
                            </div>
                        </div>
                    </section>




                    <section id="id_token_offer" className="memecoin_countdown_section section_decoration">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-lg-6">
                                    <div className="memecoin_heading_block" data-aos="fade-up" data-aos-duration="800">
                                        <h2 className="heading_text text-uppercase">
                                            ILLUSTRATIONS THAT SPEAK VOLUMES
                                        </h2>
                                        <p className="heading_description mb-0 pe-lg-5">
                                            Good illustrations, as we at GetLogoAndWebsite understand, not only do they look good; they also enable you to build a strong brand and build a stronger connection with your audience. We think that every illustration should evoke strong feelings, share a story, and capture the essence of your business. No matter if you require original images for your website, product labels, social media, or advertising campaigns, we have a team of talented artists who are prepared to turn your vision into reality. Whether they are basic and clean or imaginative and fun, we design images that complement your message and style. To make sure that each design is true to your brand, we spend time understanding your vision and goals. GetLogoAndWebsite can assist you if you're looking for creative, bold illustrations that stand out.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6 d-flex gap-5">
                                    <video muted autoPlay loop preload="none" style={{ borderRadius: "30px", width: "45%", marginLeft: "auto", position: "relative", top: "3rem" }}>
                                        <source src={VideoAnimationService1} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                    <video muted autoPlay loop preload="none" style={{ borderRadius: "30px", width: "45%", marginLeft: "auto" }}>
                                        <source src={VideoAnimationService2} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            </div>
                        </div>
                    </section>


                    <Packages />
                    <AnimationAndIllustrationTestimonial />


                </main>
                <Footer />
                <Scrollbar />
            </div>
            {isModalOpen && <Modal onClose={closeModal} />}
        </Fragment>
    )
};
export default AnimationAndIllustration;